/* eslint-disable no-else-return */
/* eslint-disable no-lonely-if */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
import { Controller, useWatch } from "react-hook-form";
import {
    Autocomplete,
    TextField,
    Checkbox,
    List,
    ListItem,
    Divider,
    Tooltip,
} from "@mui/material";
import { useState, useMemo, useEffect } from "react";
import CircularProgress from '@mui/material/CircularProgress';




const custom = ({
    handleSelectAction,
    field,
    inputValue,
    isAllFilteredSelected,
    isAllSelected,
    getSelectActionLabel,
    ...props
}) => (
    <List {...props} style={{ background: "white", color: "black" }}>
        <ListItem
            onMouseDown={(event) => event.preventDefault()} // Prevent focus loss
            onClick={() => handleSelectAction(field)} // Pass field to update form values
            sx={{
                display: "flex",
                height: "2rem",
                alignItems: "center",
                paddingLeft: "1.9em",
                fontSize: "13px",
            }}
        >
            <Checkbox
                checked={inputValue ? isAllFilteredSelected : isAllSelected}
                style={{ marginRight: 8 }}
                size="small"
            />
            <span style={{ fontSize: "13px" }}> {getSelectActionLabel()} </span>  {/* Make sure this is accessible */}
        </ListItem>
        <Divider />
        {props.children}
    </List>
);



const RHFAutocomplete = ({ formData, control, getDataFunc }) => {
    const [loading, setLoading] = useState(false);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [inputValue, setInputValue] = useState("");
    const [options, setOptions] = useState([]);
    const [debounceTimeout, setDebounceTimeout] = useState(null);

    // Strip Target_ prefix from DisplayExpr and ValueExpr for accessing API-returned option data
    // API returns fields like "Item" and "ItemId", but formData may have "Target_Item" and "Target_ItemId"
    const optionDisplayExpr = formData?.DisplayExpr?.replace(/^Target_/, '') || formData?.DisplayExpr;
    const optionValueExpr = formData?.ValueExpr?.replace(/^Target_/, '') || formData?.ValueExpr;

    const value = useWatch({ control, name: formData.ValueExpr });


    useEffect(() => {
        if (Array.isArray(value) && value.length > 0) {
            // Merge any missing items from value into options
            // This ensures edit mode values are always in the options array
            setOptions((prevOptions) => {
                const missingOptions = value.filter(
                    (valItem) =>
                        valItem && !prevOptions.some(
                            (optItem) =>
                                optItem && (optItem[optionValueExpr] === valItem[optionValueExpr] || optItem[formData.ValueExpr] === valItem[formData.ValueExpr])
                        )
                );

                // Always add missing options - this is critical for edit mode
                // where values are set before any API fetch populates options
                if (missingOptions.length > 0) {
                    return [...prevOptions, ...missingOptions];
                }

                return prevOptions;
            });

            // Ensure selectedOptions is in sync with form value
            setSelectedOptions(value);
        } else {
            setSelectedOptions([]);
        }
    }, [value, formData.ValueExpr]);

    // Additional effect to handle initial edit mode - ensure options contain the values
    // This runs once when component mounts with a pre-set value
    useEffect(() => {
        if (Array.isArray(value) && value.length > 0 && options.length === 0) {
            // Options are empty but we have values - initialize options with value items
            setOptions(value);
        }
    }, []);



    const filteredOptions = useMemo(() => {
        if (!inputValue) return options;

        if (formData.TableName === "ClaimPreview") {

            return options?.filter((option) =>
                option?.ContractName
                    ?.toLowerCase()
                    ?.includes(inputValue.toLowerCase())
            );
        }
        return options?.filter((option) =>
            (option?.[optionDisplayExpr] || option?.[formData.DisplayExpr])
                ?.toLowerCase()
                ?.includes(inputValue.toLowerCase())
        );
    }, [options, inputValue, formData.DisplayExpr, optionDisplayExpr]);



    const rules = formData?.Validations?.reduce((acc, validation) => {
        if (validation.ValidationType === "Required") {
            acc.required = validation.ValidationMessage || "This field is required";
        }
        return acc;
    }, {});

    useEffect(() => {
        // If the field value changes programmatically (like through reset), update selectedOptions
        if (control._formValues && Array.isArray(control._formValues[formData?.ValueExpr])) {
            setSelectedOptions(control._formValues[formData.ValueExpr]);
        }
    }, [control._formValues, formData.ValueExpr, options]);


    const isAllSelected = selectedOptions.length === options.length && options.length !== 0;
    const isAllFilteredSelected = selectedOptions?.length > 0 && filteredOptions.every((option) =>
        selectedOptions.some(
            (selected) => (selected[optionValueExpr] || selected[formData.ValueExpr]) === (option[optionValueExpr] || option[formData.ValueExpr])
        )
    );

    const handleSelectAction = (field) => {
        if (inputValue) {
            if (isAllFilteredSelected) {
                // Unselect filtered options
                const updatedOptions = selectedOptions.filter(
                    (selected) =>
                        !filteredOptions.some(
                            (filtered) =>
                                (filtered[optionValueExpr] || filtered[formData.ValueExpr]) === (selected[optionValueExpr] || selected[formData.ValueExpr])
                        )
                );
                setSelectedOptions(updatedOptions);
                field.onChange(updatedOptions); //  Use full objects
            } else {
                // Select filtered options
                const newSelectedOptions = [
                    ...selectedOptions,
                    ...filteredOptions.filter(
                        (filtered) =>
                            !selectedOptions.some(
                                (selected) =>
                                    (selected[optionValueExpr] || selected[formData.ValueExpr]) === (filtered[optionValueExpr] || filtered[formData.ValueExpr])
                            )
                    ),
                ];
                setSelectedOptions(newSelectedOptions);
                field.onChange(newSelectedOptions); //  Use full objects
            }
        } else {
            if (isAllSelected) {
                // Unselect all
                setSelectedOptions([]);
                field.onChange([]); //  Use full objects (empty)
            } else {
                // Select all
                setSelectedOptions(options);
                field.onChange(options); //  Use full objects
            }
        }
    };



    const getSelectActionLabel = () => {
        if (inputValue) {
            return isAllFilteredSelected
                ? "Unselect Filtered Options"
                : "Select Filtered Options";
        } else {
            return isAllSelected ? "Unselect All" : "Select All";
        }
    };

    const fetchData = async (query) => {

        setLoading(true);
        let response = null;

        if (formData?.TableName === 'ManualContractClaimGeneration' && formData?.DisplayExpr === 'ContractName') {
            response = await getDataFunc({
                "SearchText": query
            });

        }
        else if (formData?.TableName === 'ClaimPreview') {

            response = await getDataFunc({
                "SearchText": query
            });

        }
        else {
            // Strip Target_ prefix from DisplayExpr for ControlId (API expects base field name)
            const displayExprForApi = formData?.DisplayExpr?.replace(/^Target_/, '');
            response = await getDataFunc({
                "ControlId": `${formData?.TableName}-${displayExprForApi}`,
                "Values": query,
            });
        }

        let newOptions = null;
        if (formData?.TableName === 'ManualContractClaimGeneration' && formData?.DisplayExpr === 'ContractName') {
            newOptions = Array.isArray(response?.data?.DefaultValues) ? response?.data?.DefaultValues : [];
        }
        else if (formData?.TableName === 'ClaimPreview') {

            newOptions = Array.isArray(response?.DefaultValues) ? response?.DefaultValues : [];
        }
        else {
            newOptions = Array.isArray(response?.data) ? response?.data : [];
        }


        setOptions((prevOptions) => {
            const newUniqueOptions = newOptions.filter((newOption) =>
                !prevOptions.some((existingOption) => (existingOption[optionValueExpr] || existingOption[formData.ValueExpr]) === (newOption[optionValueExpr] || newOption[formData.ValueExpr]))
            );
            return [...prevOptions, ...newUniqueOptions]; // Add the new unique options
        });
        setLoading(false);

    };



    return (
        <Controller
            name={formData?.ValueExpr}
            control={control}
            rules={rules}
            render={({ field, fieldState: { error } }) => ( // NOSONAR

                <Autocomplete
                    {...field}
                    multiple
                    options={options}
                    loading={loading}

                    value={field.value ?? []}
                    inputValue={inputValue}
                    // onInputChange={handleInputChange}
                    onInputChange={(event, newInputValue, reason) => {
                        if (reason !== 'reset') {
                            setInputValue(newInputValue);

                            // If there's a previous debounce timeout, clear it
                            if (debounceTimeout) {
                                clearTimeout(debounceTimeout);
                            }

                            // Set a new timeout for the fetch call
                            const newTimeout = setTimeout(() => {
                                if (newInputValue.length >= 3) {
                                    fetchData(newInputValue);
                                }
                            }, 500); // Set delay to 500ms (can be adjusted)

                            setDebounceTimeout(newTimeout);
                        }
                    }}
                    getOptionLabel={(option) => option[optionDisplayExpr] || option[formData.DisplayExpr] || ""}
                    isOptionEqualToValue={(option, valuee) =>
                        (option[optionValueExpr] || option[formData.ValueExpr]) === (valuee[optionValueExpr] || valuee[formData.ValueExpr])
                    }
                    onChange={(event, valuee, reason) => {
                        if (!(reason === 'removeOption' && event.type === 'keydown')) {
                            setSelectedOptions(valuee);
                            field.onChange(valuee);
                        }
                    }}
                    disableCloseOnSelect
                    renderOption={(props, option, { selected }) => (
                        <li {...props} style={{ fontSize: "13px" }} key={option[optionValueExpr] || option[formData?.ValueExpr]}>
                            <Checkbox style={{ marginRight: 8 }} checked={selected} size='small' />
                            {option[optionDisplayExpr] || option[formData.DisplayExpr]}
                        </li>
                    )}
                    renderTags={(selected, getTagProps) => {
                        const label =
                            selected.length > 0 ? `${selected.length} items selected` : "";
                        return (
                            <span style={{ fontSize: "13px", paddingLeft: "0.5em" }}>
                                {label}
                            </span>
                        );
                    }}

                    slots={{
                        paper: custom,
                    }}
                    slotProps={{
                        paper: {
                            handleSelectAction,
                            field,
                            inputValue,
                            isAllFilteredSelected,
                            isAllSelected,
                            getSelectActionLabel,
                        },
                    }}

                    PaperComponent={custom}


                    renderInput={(params) => (
                        <Tooltip
                            title={
                                <div
                                    style={{
                                        maxHeight: '150px',
                                        overflowY: field?.value != null && field.value?.length > 3 ? 'auto' : 'hidden', // Show scrollbar only if there are more than 3 items
                                    }}
                                >
                                    <span
                                        style={{
                                            color: '#9e9e9e',
                                            fontSize: '13px',
                                            fontWeight: '300',
                                        }}
                                    >

                                        {Array.isArray(field?.value) && field.value.length > 0
                                            && field.value.map(item => item?.[optionDisplayExpr] || item?.[formData?.DisplayExpr]).join(", ")
                                        }


                                    </span>
                                </div>
                            }
                            arrow
                            placement="top"
                            PopperProps={{
                                sx: {
                                    '& .MuiTooltip-tooltip': {
                                        backgroundColor: 'white', // White background
                                        color: 'black', // Black text
                                        border: '1px solid #ccc', // Optional: subtle border for better visibility
                                        boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1), 0px 4px 4px rgba(0, 0, 0, 0.25)',
                                    },
                                    '& .MuiTooltip-arrow': {
                                        color: 'white', // Match the arrow color with the tooltip background
                                    },
                                    display: field.value == null || field.value?.length === 0 ? 'none' : ''
                                },
                            }}
                        >
                            <TextField
                                {...params}
                                label={<>{formData?.LabelName || formData?.DisplayExpr}{rules?.required && (
                                    <span style={{ color: "red", marginLeft: "2px" }}>*</span>
                                )}</>}
                                variant="outlined"
                                size="small"
                                // error={!!error}
                                InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                        <>
                                            {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                            {params.InputProps.endAdornment}
                                        </>
                                    ),
                                }}

                                helperText={
                                    error && <span style={{ color: "red", fontSize: "10px" }}>{error.message}</span>
                                }
                                fullWidth
                                sx={{
                                    "& .MuiInputBase-input": {
                                        fontSize: "13px",
                                    },
                                    "& .MuiFormLabel-root": {
                                        fontSize: "14px",
                                    },
                                }}
                            />
                        </Tooltip>
                    )}
                />


            )}
        />
    );
};

export default RHFAutocomplete;
